export default "__VITE_ASSET__Cy$2NICB__"